import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Header from '../header/header';
import Main from '../main/main';
import About from '../about/about';
import Skills from '../skills/skills';
import Portfolio from '../portfolio/portfolio';
import Experience from '../experience/experience';
import Contacts from '../contacts/contacts';
import Footer from '../footer/footer';
import styles from './initial.module.scss';
import { setNewLanguage } from '../../redux/actions';



const sectionPathMap = {
    '/about': 'about',
    '/skills': 'skills',
    '/portfolio': 'portfolio',
    '/experience': 'experience',
    '/contacts': 'contacts'
};

const Initial = ({history, location, setNewLanguage}) => {
    const [isLanguage, setIsLanguage] = useState(false);
    const refSeparator = useRef();
    const aboutRef = useRef();
    const skillsRef = useRef();
    const portfolioRef = useRef();
    const experienceRef = useRef();
    const contactsRef = useRef();

    const sectionRefs = useRef({
        about: aboutRef,
        skills: skillsRef,
        portfolio: portfolioRef,
        experience: experienceRef,
        contacts: contactsRef
    });
    
    useEffect(() => {
        const lang = localStorage.getItem('language');
        if (lang) {
            setNewLanguage(lang);
        }
        setIsLanguage(true);
    }, [setNewLanguage]);

    useEffect(() => {
        if (!isLanguage) {
            return;
        }

        const hashSection = location.hash.replace('#', '');
        const routeSection = sectionPathMap[location.pathname];

        if (location.pathname === '/' && !hashSection) {
            return;
        }

        if (location.pathname === '/') {
            const nextSection = sectionRefs.current[hashSection];

            if (nextSection && nextSection.current) {
                window.requestAnimationFrame(() => {
                    nextSection.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
                });
            }

            return;
        }

        if (!routeSection) {
            history.replace('/');
            return;
        }

        const targetSection = hashSection || routeSection;

        window.requestAnimationFrame(() => {
            const nextSection = sectionRefs.current[targetSection];

            if (nextSection && nextSection.current) {
                nextSection.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
        });

        const nextHash = targetSection ? `#${targetSection}` : '';
        history.replace(`/${nextHash}`);
    }, [history, isLanguage, location.hash, location.pathname]);

    const navigateToSection = (sectionId) => {
        if (location.pathname !== '/' || location.hash !== `#${sectionId}`) {
            history.push(`/#${sectionId}`);
            return;
        }

        const nextSection = sectionRefs.current[sectionId];

        if (nextSection && nextSection.current) {
            nextSection.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    };

    return(
        <>
            {isLanguage ? 
            <div className={styles.container}>
                <Header navigateToSection={navigateToSection} refSeparator={refSeparator} />
                <Main navigateToSection={navigateToSection} />
                <div ref={refSeparator}></div>
                <div className={styles.sectionArea}>
                    <div ref={aboutRef} id='about' className={styles.sectionBlock}>
                        <About />
                    </div>
                    <div ref={skillsRef} id='skills' className={styles.sectionBlock}>
                        <Skills showHelmet={false} />
                    </div>
                    <div ref={portfolioRef} id='portfolio' className={styles.sectionBlock}>
                        <Portfolio showHelmet={false} />
                    </div>
                    <div ref={experienceRef} id='experience' className={styles.sectionBlock}>
                        <Experience showHelmet={false} />
                    </div>
                    <div ref={contactsRef} id='contacts' className={styles.sectionBlock}>
                        <Contacts showHelmet={false} />
                    </div>
                </div>
                <Footer />
            </div>
            :
            <div></div>}
        </>
    )
}

const mapStateToProps = (state) => {
    return{
        words: state.main.words
    };
};

const initialCompose = compose(withRouter, connect(mapStateToProps, {setNewLanguage}))(Initial);

export default initialCompose;
